<template>
    <div class="containerInner">
        <div class="listHeader">
            <div class="headerLeftMenu">
                <span>表示条件</span>
                <template v-if="mallAdTabActive != 3">
                    <span>
                        <input class="searchInputText" type="text" :placeholder="computedPlaceholder"
                            v-model="searchKeyword" @keydown="enterSearch">
                    </span>
                </template>

                <span>
                    <select v-model="searchServiceId">
                        <option value="">全店舗</option>
                        <option v-for="service in filteredService()" :value="service.id" v-bind:key="service.id">
                            （{{ service.id }}）{{ service.name }}</option>
                    </select>
                </span>

                <template v-if="mallAdTabActive == 0">
                    <span>
                        <Datepicker class="datepicker" :maximumView="'month'" :minimumView="'month'" format="yyyy-MM"
                            v-model="firstDateOfthisMonth" :language="ja" placeholder="配信開始日" />
                    </span>
                </template>

                <template v-if="mallAdTabActive == 3">
                    <span>
                        <select v-model="searchMallAdTypeId">
                            <option value="">全て</option>
                            <option v-for="(type) in media.mallAdType" :value="type[0]" v-bind:key="type[0]">
                                （{{ type[0] }}）{{ type[1] }}</option>
                        </select>
                    </span>
                </template>

                <span>
                    <a class="btn searchBtn" @click="searchItem">検索</a>
                </span>

                <span>
                    <a class="btn clearBtn" @click="searchClear">条件クリア</a>
                </span>
            </div>
            <div class="headerRightMenu">
                <template v-if="mallAdTabActive == 0">
                    <Button @click="csvDownloadMallAd">CSVフォーマット</Button>
                    <Button @click="$modal.show('mallAdCsv')" class="ml10">CSVアップロード</Button>
                    <Button @click="openCreateModal" class="ml10">新規追加</Button>
                </template>

                <template v-if="mallAdTabActive == 1">
                    <Button @click="csvDownloadMallPoint">CSVフォーマット</Button>
                    <Button @click="$modal.show('mallPointCsv')" class="ml10">CSVアップロード</Button>
                    <Button @click="openCreatePointMeasuresModal" class="ml10">新規追加</Button>
                </template>

                <template v-if="mallAdTabActive == 2">
                    <Button @click="csvDownloadMallEvent">CSVフォーマット</Button>
                    <Button @click="$modal.show('mallEventCsv')" class="ml10">CSVアップロード</Button>
                    <Button @click="openCreateMallEventModal" class="ml10">新規追加</Button>
                </template>

                <template v-if="mallAdTabActive == 3">
                    <Button @click="openCreateAdMinusModal" class="ml10">新規追加</Button>
                </template>
            </div>
        </div>

        <template v-if="searchDateFlg && mallAdTabActive == 0">
            <div class="listHeaderDetail">
                <div class="headerLeftMenu">
                    <span>広告本数：</span>
                    <span>
                        <p class="adDetailData">{{ this.adCount }}本</p>
                    </span>
                    <span>広告費合計：</span>
                    <span>
                        <p class="adDetailData">{{ this.sumCost | priceLocaleString }}</p>
                    </span>
                </div>
            </div>
        </template>


        <div class="mallAdWrapper">
            <div class="mallAdTab">
                <button class="mallAdTabBtn" v-bind:class="{ 'active': mallAdTabActive == 0 }"
                    @click="showAdCost">モール広告費</button>
                <button class="mallAdTabBtn" v-bind:class="{ 'active': mallAdTabActive == 3 }"
                    @click="showAdMinusCost">費用調整</button>
                <button class="mallAdTabBtn" v-bind:class="{ 'active': mallAdTabActive == 1 }"
                    @click="showPointMeasures">モール施策設定</button>
                <button class="mallAdTabBtn" v-bind:class="{ 'active': mallAdTabActive == 2 }"
                    @click="showMallEvent">モールイベント</button>
            </div>
            <div class="table-container">
                <table id="MallAdTable">
                    <thead>
                        <tr v-if="mallAdTabActive == 0">
                            <th class="th_sticky_1">店舗</th>
                            <th class="th_sticky_2">配信開始日</th>
                            <th class="th_sticky_3">配信終了日</th>
                            <th>施策開始日</th>
                            <th>施策終了日</th>
                            <th>広告商品名</th>
                            <th>枠名</th>
                            <th>配信対象商品</th>
                            <th>広告費</th>
                            <th>売上</th>
                            <th>数量</th>
                            <th>ROAS</th>
                        </tr>

                        <tr v-if="mallAdTabActive == 1">
                            <th class="th_sticky_1">店舗</th>
                            <th>開始日</th>
                            <th>終了日</th>
                            <th>対象商品</th>
                            <th>ポイント倍率</th>
                        </tr>

                        <tr v-if="mallAdTabActive == 2">
                            <th class="th_sticky_1">店舗</th>
                            <th>開始日時</th>
                            <th>終了日時</th>
                            <th>イベント名</th>
                        </tr>

                        <tr v-if="mallAdTabActive == 3">
                            <th class="th_sticky_1">店舗</th>
                            <th>広告種類</th>
                            <th>調整開始日</th>
                            <th>調整終了日</th>
                            <th>調整金額</th>
                            <th>対象商品</th>
                        </tr>
                    </thead>
                    <tbody class="selectRoasRow">
                        <template v-if="mallAdTabActive == 0">
                            <tr v-for="item in this.ads" :key="item['id']" @click="openEditModal(item['id'])">
                                <td class="td_sticky_1">
                                    （{{ item['service_id'] }}）{{ item['service_name'] }}
                                    <span v-if="item['mall_ad_type_name']">
                                        （{{ item['mall_ad_type_id'] }}：{{ item['mall_ad_type_name'] }}）
                                    </span>
                                </td>
                                <td class="td_sticky_2">{{ item['start_date'] }}</td>
                                <td class="td_sticky_3">{{ item['end_date'] }}</td>
                                <td>{{ item['shisaku_start_date'] }}</td>
                                <td>{{ item['shisaku_end_date'] }}</td>
                                <td>{{ item['ad_name'] }}</td>
                                <td>{{ item['channel_name'] }}</td>
                                <td>{{ productNames(item['products']) }}</td>
                                <td class="price">{{ item['cost'] | priceLocaleString }}</td>
                                <td class="price">{{ item['sales'] | priceLocaleString }}</td>
                                <td>{{ item['count'] }}</td>
                                <td>{{ item['roas'] | percentDisp }}</td>
                            </tr>
                        </template>

                        <template v-if="mallAdTabActive == 1">
                            <tr v-for="item in this.ads" :key="item['id']"
                                @click="openEditPointMeasuresModal(item['id'])">
                                <td class="td_sticky_1">（{{ item['service_id'] }}）{{ item['service_name'] }}</td>
                                <td>{{ item['start_day'] }}</td>
                                <td>{{ item['end_day'] }}</td>
                                <td>{{ productNames(item['products']) }}</td>
                                <td>{{ rateFmt(item['rate']) }}%</td>
                            </tr>
                        </template>

                        <template v-if="mallAdTabActive == 2">
                            <tr v-for="item in this.ads" :key="item['id']" @click="openEditMallEventModal(item['id'])">
                                <td class="td_sticky_1">（{{ item['service_id'] }}）{{ item['service_name'] }}</td>
                                <td>{{ item['start_day'] + ' ' + item['start_time'] }}</td>
                                <td>{{ item['end_day'] + ' ' + item['end_time'] }}</td>
                                <td>{{ item['event_name'] }}</td>
                            </tr>
                        </template>

                        <template v-if="mallAdTabActive == 3">
                            <tr v-for="item in this.ads" :key="item['id']" @click="openEditAdMinusModal(item['id'])">
                                <td class="td_sticky_1">（{{ item['service_id'] }}）{{ item['service_name'] }}</td>
                                <td>（{{ item['mall_ad_type_id'] }}）{{ item['mall_ad_type_name'] }}</td>
                                <td>{{ item['start_date'] }}</td>
                                <td>{{ item['end_date'] }}</td>
                                <td class="price">{{ item['cost'] | priceLocaleString }}</td>
                                <td>{{ productNames(item['products']) }}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>

        </div>
        <modal name="mallAdModal" :draggable="false" :resizable="false" width="80%" height="99%">
            <MallAdModal :adId="this.selectedId" :createMode="this.createMode"
                @modalClosed="modalClosed('mallAdModal')" />
        </modal>
        <modal name="mallPointModal" :draggable="false" :resizable="false" width="70%" height="99%">
            <MallPointModal :pointId="this.selectedId" :createMode="this.createMode"
                @modalClosed="modalClosed('mallPointModal')" />
        </modal>
        <modal name="mallEventModal" :draggable="false" :resizable="false" width="70%" height="99%">
            <MallEventModal :eventId="this.selectedId" :createMode="this.createMode"
                @modalClosed="modalClosed('mallEventModal')" />
        </modal>
        <modal name="mallAdMinusModal" :draggable="false" :resizable="false" width="70%" height="99%">
            <MallAdMinusModal :adId="this.selectedId" :createMode="this.createMode"
                @modalClosed="modalClosed('mallAdMinusModal')" />
        </modal>


        <modal name="mallAdCsv" :draggable="false" :resizable="false" :clickToClose="false" width="700px" height="auto">
            <MallAdUploadCsv @uploaded="fetchRakutenMallAds" @modalClosed="hideModalMallAdUploadCsv" />
        </modal>

        <modal name="mallPointCsv" :draggable="false" :resizable="false" :clickToClose="false" width="700px"
            height="auto">
            <MallPointUploadCsv @uploaded="fetchMallPoints" @modalClosed="hideModalMallPointUploadCsv" />
        </modal>

        <modal name="mallEventCsv" :draggable="false" :resizable="false" :clickToClose="false" width="700px"
            height="auto">
            <MallEventUploadCsv @uploaded="fetchMallEvents" @modalClosed="hideModalMallEventUploadCsv" />
        </modal>


        <div class="loading-window" v-show="this.$store.state.loading">
            <div class="loading-window-inner">
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1"></vue-loaders>
            </div>
        </div>
    </div>
</template>

<script>

import MallAdModal from '../components/MallAdModal.vue';
import MallPointModal from '../components/MallPointModal.vue';
import MallEventModal from '../components/MallEventModal.vue';
import MallAdMinusModal from '../components/MallAdMinusModal.vue';
import MallAdUploadCsv from './MallAdUploadCsv.vue';
import MallPointUploadCsv from './MallPointUploadCsv.vue';
import MallEventUploadCsv from './MallEventUploadCsv.vue';
import { saveAs } from 'file-saver'
import Encoding from 'encoding-japanese'
import { mapGetters } from 'vuex';
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'

export default {
    name: 'MallAd',
    data() {
        return {
            mallAdTabActive: 0,
            ads: [],
            createMode: false,
            selectedId: null,
            services: {},
            searchKeyword: "",
            searchServiceId: "",
            searchMallAdTypeId: "",
            ja: ja,
            firstDateOfthisMonth: null,
            searchDateFlg: false,
            adCount: 0,
            sumCost: 0,
        }
    },
    components: {
        MallAdModal,
        MallPointModal,
        MallEventModal,
        MallAdMinusModal,
        MallAdUploadCsv,
        MallPointUploadCsv,
        MallEventUploadCsv,
        Datepicker,
    },
    mounted: function () {
        this.fetchRakutenMallAds();

        //サービス名プルダウンセット
        this.getServiceId();
    },
    methods: {
        openCreateModal: function () {
            this.selectedId = null;
            this.createMode = true;
            this.$modal.show('mallAdModal');
        },
        openEditModal: function (productId) {
            this.selectedId = productId;
            this.createMode = false;
            this.$modal.show('mallAdModal');
        },
        async fetchRakutenMallAds() {
            this.$store.dispatch("loading", true);
            var url = "/api/mallAdCosts/rakutenMarketAds";
            var data = {
            }
            await this.axios.get(url, { params: data })
                .then((res) => {
                    this.ads = [...res.data.list];
                }).catch(() => {
                }).finally(() => {
                    this.$nextTick(() => {
                        this.setStickyPositions();
                    });
                    this.$store.dispatch("loading", false);
                });
        },
        setStickyPositions() {
            const th1_stickyElement = this.$el.querySelector(".th_sticky_1");
            const th1_offsetwidth = th1_stickyElement.getBoundingClientRect().width;

            const th2_stickyElement = this.$el.querySelector(".th_sticky_2");
            const th2_offsetwidth = th2_stickyElement.getBoundingClientRect().width;

            th2_stickyElement.style.left = `${th1_offsetwidth}px`;

            const td2_stickyElements = this.$el.querySelectorAll(".td_sticky_2");
            td2_stickyElements.forEach(stickyElement => {
                stickyElement.style.left = `${th1_offsetwidth}px`;
            });


            const th3_offsetleft = parseFloat(th1_offsetwidth) + parseFloat(th2_offsetwidth);


            const th3_stickyElement = this.$el.querySelector(".th_sticky_3");
            th3_stickyElement.style.left = `${th3_offsetleft}px`;

            const td3_stickyElements = this.$el.querySelectorAll(".td_sticky_3");
            td3_stickyElements.forEach(stickyElement => {
                stickyElement.style.left = `${th3_offsetleft}px`;
            });
        },
        async fetchMallPoints() {
            this.$store.dispatch("loading", true);
            var url = "/api/mallAdCosts/MallPoints";
            var data = {
            }
            await this.axios.get(url, { params: data })
                .then((res) => {
                    this.ads = [...res.data];
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        async fetchMallEvents() {
            this.$store.dispatch("loading", true);
            var url = "/api/mallAdCosts/MallEvents";
            var data = {
            }
            await this.axios.get(url, { params: data })
                .then((res) => {
                    this.ads = [...res.data];
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        async fetchMallAdMinus() {
            this.$store.dispatch("loading", true);
            var url = "/api/mallAdCosts/MallAdMinus";
            var data = {
            }
            await this.axios.get(url, { params: data })
                .then((res) => {
                    this.ads = [...res.data];
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        //モール施策新規追加
        openCreatePointMeasuresModal: function () {
            this.selectedId = null;
            this.createMode = true;
            this.$modal.show('mallPointModal');
        },
        openEditPointMeasuresModal: function (pointId) {
            this.selectedId = pointId;
            this.createMode = false;
            this.$modal.show('mallPointModal');
        },
        //モールイベント新規追加
        openCreateMallEventModal: function () {
            this.selectedId = null;
            this.createMode = true;
            this.$modal.show('mallEventModal');
        },
        openEditMallEventModal: function (eventId) {
            this.selectedId = eventId;
            this.createMode = false;
            this.$modal.show('mallEventModal');
        },
        //費用調整新規追加
        openCreateAdMinusModal: function () {
            this.selectedId = null;
            this.createMode = true;
            this.$modal.show('mallAdMinusModal');
        },
        openEditAdMinusModal: function (adId) {
            this.selectedId = adId;
            this.createMode = false;
            this.$modal.show('mallAdMinusModal');
        },
        // 文字列検索
        searchItem: function () {
            this.$store.dispatch("loading", true);
            this.currentPage = 1;

            if (this.mallAdTabActive == 0) {
                var month = null;
                this.adCount = 0;
                this.sumCost = 0;

                if (this.firstDateOfthisMonth != null) {
                    month = (this.firstDateOfthisMonth.getFullYear()) + '-' + (this.firstDateOfthisMonth.getMonth() + 1);
                    this.searchDateFlg = true;
                }
                else {
                    this.searchDateFlg = false;
                }

                this.axios.get("/api/mallAdCosts/rakutenMarketAds?page=1", { params: { searchWords: this.searchKeyword, searchServiceId: this.searchServiceId, searchStartDate: month } })
                    .then((res) => {
                        this.ads = [...res.data.list];
                        this.adCount = this.ads.length;
                        this.sumCost = res.data.sumCost;
                    }).catch(() => {
                    }).finally(() => {
                        this.$nextTick(() => {
                            this.setStickyPositions();
                        });
                        this.$store.dispatch("loading", false);
                    });
            }
            else if (this.mallAdTabActive == 1) {
                this.axios.get("/api/mallAdCosts/MallPoints?page=1", { params: { searchWords: this.searchKeyword, searchServiceId: this.searchServiceId } })
                    .then((res) => {
                        this.ads = [...res.data];
                    }).catch(() => {
                    }).finally(() => {
                        this.$store.dispatch("loading", false);
                    });
            }
            else if (this.mallAdTabActive == 2) {
                this.axios.get("/api/mallAdCosts/MallEvents?page=1", { params: { searchWords: this.searchKeyword, searchServiceId: this.searchServiceId } })
                    .then((res) => {
                        this.ads = [...res.data];
                    }).catch(() => {
                    }).finally(() => {
                        this.$store.dispatch("loading", false);
                    });
            }
            else if (this.mallAdTabActive == 3) {
                this.axios.get("/api/mallAdCosts/MallAdMinus?page=1", { params: { searchServiceId: this.searchServiceId, searchMallAdTypeId: this.searchMallAdTypeId } })
                    .then((res) => {
                        this.ads = [...res.data];
                    }).catch(() => {
                    }).finally(() => {
                        this.$store.dispatch("loading", false);
                    });
            }
        },
        //条件クリア
        searchClear: function () {
            this.searchKeyword = "";
            this.searchServiceId = "";
            this.searchMallAdTypeId = "";
            this.firstDateOfthisMonth = null;
        },
        // エンターキーが押された時に文字列検索を実行
        enterSearch: function (e) {
            if (e.keyCode == 13) {
                this.searchItem();
            }
        },
        //モール広告費タブがクリックされた場合
        showAdCost: function () {
            this.mallAdTabActive = 0;
            this.ads = [];
            this.searchKeyword = "";
            this.searchServiceId = "";
            this.searchMallAdTypeId = "";
            this.adCount = 0;
            this.sumCost = 0;
            this.fetchRakutenMallAds();
        },
        //費用調整タブがクリックされた場合
        showAdMinusCost: function () {
            this.mallAdTabActive = 3;
            this.ads = [];
            this.searchKeyword = "";
            this.searchServiceId = "";
            this.searchMallAdTypeId = "";
            this.fetchMallAdMinus();
        },
        //モール施策設定タブがクリックされた場合
        showPointMeasures: function () {
            this.mallAdTabActive = 1;
            this.ads = [];
            this.searchKeyword = "";
            this.searchServiceId = "";
            this.searchMallAdTypeId = "";
            this.fetchMallPoints();
        },
        //モールイベントタブがクリックされた場合
        showMallEvent: function () {
            this.mallAdTabActive = 2;
            this.ads = [];
            this.searchKeyword = "";
            this.searchServiceId = "";
            this.searchMallAdTypeId = "";
            this.fetchMallEvents();
        },
        modalClosed(modalName) {
            if (this.mallAdTabActive == 0) {
                this.fetchRakutenMallAds();
            }
            else if (this.mallAdTabActive == 1) {
                this.fetchMallPoints();
            }
            else if (this.mallAdTabActive == 2) {
                this.fetchMallEvents();
            }
            else if (this.mallAdTabActive == 3) {
                this.fetchMallAdMinus();
            }
            this.$modal.hide(modalName)
        },
        productNames: function (product_list) {
            var name = "";
            for (var product of product_list) {
                if (product["id"] == -1) {
                    name += "【0】全商品"
                }
                else {
                    name += "【" + product["id"] + "】" + product["name"];
                }
            }
            return name;
        },
        rateFmt: function (rate) {
            var reRate = rate * 100;
            return reRate;
        },
        //サービスIDの一覧取得
        getServiceId: function () {
            this.axios.get("/api/service/")
                .then((res) => {
                    this.services = res.data;
                }).catch(() => {
                }).finally(() => {
                });
        },
        filteredService() {
            let result = [];
            let list = [4, 10, 26, 28, 55];

            if (this.mallAdTabActive == 3) {
                list = [4, 10];
            }

            for (var idx in this.services) {
                let service = this.services[idx];
                if (list.includes(service.id)) {
                    result.push(service);
                }
            }

            if (this.mallAdTabActive != 0 && this.mallAdTabActive != 3) {
                result.push({ id: 100, name: '楽天全店' });
            }
            return result;
        },
        hideModalMallAdUploadCsv() {
            this.$modal.hide('mallAdCsv')
        },
        hideModalMallPointUploadCsv() {
            this.$modal.hide('mallPointCsv')
        },
        hideModalMallEventUploadCsv() {
            this.$modal.hide('mallEventCsv')
        },

        //CSVフォーマットダウンロード
        csvDownloadMallAd() {
            let url = '/api/mallAdCosts/csvMallAdD';

            this.axios.get(url)
                .then((res) => {
                    // convert encoding. (utf-8 → shift-jis)
                    const unicodeList = Encoding.stringToCode(res.data);
                    const shiftJisCodeList = Encoding.convert(unicodeList, 'sjis', 'unicode');
                    const shiftJisString = new Uint8Array(shiftJisCodeList);

                    // save
                    const fileName = 'Format_MallAd.csv'
                    let blob = new Blob([shiftJisString], { type: 'text/csv;charset=sjis' })
                    saveAs(blob, fileName);
                }).catch(e => {
                    this.$message.error(e.response.data.message)
                })
        },
        csvDownloadMallPoint() {
            let url = '/api/mallAdCosts/csvMallPointD';

            this.axios.get(url)
                .then((res) => {
                    // convert encoding. (utf-8 → shift-jis)
                    const unicodeList = Encoding.stringToCode(res.data);
                    const shiftJisCodeList = Encoding.convert(unicodeList, 'sjis', 'unicode');
                    const shiftJisString = new Uint8Array(shiftJisCodeList);

                    // save
                    const fileName = 'Format_MallPoint.csv'
                    let blob = new Blob([shiftJisString], { type: 'text/csv;charset=sjis' })
                    saveAs(blob, fileName);
                }).catch(e => {
                    this.$message.error(e.response.data.message)
                })
        },
        csvDownloadMallEvent() {
            let url = '/api/mallAdCosts/csvMallEventD';

            this.axios.get(url)
                .then((res) => {
                    // convert encoding. (utf-8 → shift-jis)
                    const unicodeList = Encoding.stringToCode(res.data);
                    const shiftJisCodeList = Encoding.convert(unicodeList, 'sjis', 'unicode');
                    const shiftJisString = new Uint8Array(shiftJisCodeList);

                    // save
                    const fileName = 'Format_MallEvent.csv'
                    let blob = new Blob([shiftJisString], { type: 'text/csv;charset=sjis' })
                    saveAs(blob, fileName);
                }).catch(e => {
                    this.$message.error(e.response.data.message)
                })
        },
    },
    watch: {
    },
    computed: {
        computedPlaceholder() {
            if (this.mallAdTabActive === 0) {
                return '広告商品名';
            } else if (this.mallAdTabActive === 1) {
                return '対象商品';
            } else if (this.mallAdTabActive === 2) {
                return 'イベント名';
            } else {
                return ''; // デフォルト値（必要に応じて変更）
            }
        },
        ...mapGetters({
            media: 'media/allmedia'
        }),
    }
}
</script>

<style scoped lang="sass">
.containerInner
    overflow: hidden
    .loading-window
        background: rgba(255, 255, 255, 0.8)
        height: 100%
        left: 0
        position: absolute
        top: 0px
        width: 100vw
        z-index: 1000
        .loading-window-inner
            left: 50%
            position: absolute
            text-align: center
            top: 50%
            transform: translate(-50%, -50%)
            z-index: 1000
            p
                font-size: 2.5rem
                margin-bottom: 40px
    .listHeader
        color: $grayColor
        display: flex
        font-size: 1.4rem
        margin: 20px 140px 0 140px
        padding: 10px 0
        .headerLeftMenu
            flex: 1 1 50%
            span
                display: inline-block
                vertical-align: middle
                .searchInputText
                    margin-left: 20px
                    padding: 10px
                    width: 200px
                    &:focus
                        outline: 2px solid $mainColor
                .searchBtn
                    border: 1px solid $mainColor
                    margin: 0 20px 0 10px
                    padding: 12px
                    width: 60px
                    &:hover
                        border: 1px solid $mainColor
                .clearBtn
                    border: 1px solid $mainColor
                    margin: 0
                    padding: 12px
                    width: 100px
                    &:hover
                        border: 1px solid $mainColor
                select
                    margin-left: 15px
                    padding: 10px
                    width: 200px
                .datepicker
                    margin-left: 15px;
    .listHeaderDetail
        color: $grayColor
        display: flex
        font-size: 1.4rem
        margin: 20px 140px 0 140px
        padding: 10px 0
        font-size: 20px
        .headerLeftMenu
            flex: 1 1 50%
            span
                display: inline-block
                vertical-align: middle
                .adDetailData
                    font-weight: 700;
                    margin-right: 20px;
    .mallAdWrapper
        margin: 0 140px
    .mallAdTab
        display: flex
        align-items: flex-end
        gap: 3px
        .mallAdTabBtn
            display: flex
            justify-content: center
            align-items: center
            width: 200px
            height: 30px
            border: none
            background: #C0C0C0
            border-radius: 5px 5px 0 0
            color: #FFF
            font-size: 1.2rem
            cursor: pointer
            &.active
                height: 38px
                background: $grayColor
    .table-container
        max-height: 75vh;
        overflow-y: auto;
    #MallAdTable
        position: relative
        z-index: 1
        width: 100%
        border-collapse: separate
        margin: 0px auto
        white-space: nowrap
        font-size: 1.4rem
        thead
            position: sticky
            top: 0
            width: 100%
            z-index: 2
            th
                position: relative
                background: $grayColor
                border: 1px solid #bbb
                color: $whiteColor
                padding: 10px 5px
                text-align: left
                top: 0
                vertical-align: middle
            .th_sticky_1
                position: sticky
                left: 0
                z-index: 1
                background: none;
                border: none;
                &:before
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 98%;
                    border: 1px solid #bbb
                    background: $grayColor
                    z-index: -1;
            .th_sticky_2
                position: sticky
                left: 0
                z-index: 1
                background: none;
                border: none;
                &:before
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 98%;
                    border: 1px solid #bbb
                    background: $grayColor
                    z-index: -1;
            .th_sticky_3
                position: sticky
                left: 0
                z-index: 1
                background: none;
                border: none;
                &:before
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 98%;
                    border: 1px solid #bbb
                    background: $grayColor
                    z-index: -1;
        tbody
            tr
                background: $whiteColor
                cursor: pointer
            tr:nth-child(odd)
                background: #eee
                .td_sticky_1
                    &:before
                        background: #eee
                .td_sticky_2
                    &:before
                        background: #eee
                .td_sticky_3
                    &:before
                        background: #eee
            tr:nth-child(even)
                background: $whiteColor
                .td_sticky_1
                    &:before
                        background: $whiteColor
                .td_sticky_2
                    &:before
                        background: $whiteColor
                .td_sticky_3
                    &:before
                        background: $whiteColor
            .td_sticky_1
                position: sticky
                left: 0
                z-index: 1
                background: none;
                border: none;
                &:before
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 98%;
                    border: 1px solid #bbb
                    background: inherit
                    z-index: -1;
            .td_sticky_2
                position: sticky
                left: 0
                z-index: 1
                background: none;
                border: none;
                &:before
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 98%;
                    border: 1px solid #bbb
                    background: inherit
                    z-index: -1;
            .td_sticky_3
                position: sticky
                left: 0
                z-index: 1
                background: none;
                border: none;
                &:before
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 98%;
                    border: 1px solid #bbb
                    background: inherit
                    z-index: -1;
        tfoot
            tr
                position: sticky
                bottom: 0
                z-index: 3
                background: $whiteColor
        tr, tr:nth-child(odd)
            &:hover
                background-color: #c8f0e8
        tr, tr:nth-child(even)
            &:hover
                background-color: #c8f0e8
    .selectRoasRow
        color: $grayColor
        position: relative
        td
            border: 1px solid #bbb
            padding: 5px
            text-align: left
        td.price
            text-align: right
        td:nth-child(1), td:nth-child(2), td:nth-child(3)
            text-align: left
        td.stock-link
            cursor: pointer
            text-align: center
            padding: 0
            a
                display: inline-block
                font-weight: 700
                width: 100%
                height: 100%
                color: #02AD90
                text-decoration: underline #02AD90
            a:hover
                color: black
    .ml10
        margin-left: 10px;
@include sp()
    .containerInner
        .listHeader
            display: block
            margin: 20px 0 0 10px
            .headerRightMenu
                margin-top: 20px
        .listHeaderDetail
            margin: 0
            font-size: 18px
        .mallAdWrapper
            margin: 20px 0 0
        #MallAdTable
            thead
                .th_sticky_2
                    position: static
                    background: $grayColor
                    border: 1px solid #bbb
                    &:before
                        content: none;
                        position: static;
                        top: auto;
                        left: auto;
                        width: auto;
                        height: auto;
                        border: none;
                        background: none;
                        z-index: auto;
                .th_sticky_3
                    position: static
                    background: $grayColor
                    border: 1px solid #bbb
                    &:before
                        content: none;
                        position: static;
                        top: auto;
                        left: auto;
                        width: auto;
                        height: auto;
                        border: none;
                        background: none;
                        z-index: auto;
            tbody
                .td_sticky_2
                    position: static
                    border: 1px solid #bbb
                    &:before
                        content: none;
                        position: static;
                        top: auto;
                        left: auto;
                        width: auto;
                        height: auto;
                        border: none;
                        background: none;
                        z-index: auto;
                .td_sticky_3
                    position: static
                    border: 1px solid #bbb
                    &:before
                        content: none;
                        position: static;
                        top: auto;
                        left: auto;
                        width: auto;
                        height: auto;
                        border: none;
                        background: none;
                        z-index: auto;
</style>
